import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useState, useContext, useEffect } from "react";
import {
  BASE_URL,
  MY_BRANCH_LIST,
  MY_BRANCH_AGGREGATED_DATA,
} from "utilFunctions/Constants/urlConstants";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import BranchHealthFilter from "Pages/BranchHealth/BranchHealthFilter";
import BranchHealthHeader from "Pages/BranchHealth/BranchHealthHeader";
import BranchHealthTable from "Pages/BranchHealth/BranchHealthTable";
import { Card } from "reactstrap";
import Paginator from "utilFunctions/shared/Paginator";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import useMasterContext from "Context/MasterContext";
import BranchhealthTip from "Pages/BranchHealth/BranchHealthTip";
import { LOPDashboardContext } from "Context/LOPDashboard";
const SORT_ASC = "ASC";

const BranchHealthTableHeading = [
  { label: "Branch name", value: "branchName" },
  { label: "Branch code", value: "branchCode" },
  { label: "Region", value: "region" },
  { label: "State", value: "state" },
  { label: "Active", value: "active" },
  { label: "Moderate risk", value: "moderateRisk" },
  { label: "High risk", value: "highRisk" },
  { label: "Alarming risk", value: "alarmingRisk" },
];
function BranchHealthHome() {
  const { screen }: any = useWindowSize();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const { LOPDashboard, setLOPDashboard } =
    useContext<any>(LOPDashboardContext);
  const ToastDispatch = useContext(ToastContextDispatch);

  const [BranchData, setBranchData] = useState<any>([]);
  const [BranchAggregatedData, setBranchAggregatedData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>("branchName");
  const [region, setRegion] = useState<any>();
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterState, setFilterState] = useState<any>({
    region: null,
    stream:
      masters.streams && masters.streams[0] != undefined
        ? masters.streams[0]
        : null,
    clazz: null,
    state: null,
    branchCode: null,
  });
  const [pagination, setPagination] = useState({
    totalCount: "",
    totalPage: "",
    currentPage: "",
    nextPage: "",
    nextPageUrl: "",
    previousPageUrl: "",
  });

  const { makeRequest: GetBranchData, loading: tableloading } = useGetApi(
    (data) => {
      if (data["data"] && data["data"].length) {
        setBranchData(data["data"] || []);
        setPagination({
          totalCount: data.totalCount,
          totalPage: data.totalPage,
          currentPage: data.currentPage,
          nextPage: data?.nextPage ? data.nextPage : 0,
          previousPageUrl: data?.previousPageUrl ? data.previousPageUrl : "",
          nextPageUrl: data?.nextPageUrl ? data.nextPageUrl : "",
        });
      } else {
        setBranchData([]);
      }
    },
    (error) => {
      setBranchData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const {
    makeRequest: GetBranchAggregatedData,
    loading: aggregatedDataLoading,
  } = useGetApi(
    (data) => {
      if (data["data"] && Object.entries(data["data"]).length) {
        const aggregatedDataArray = Object.entries(data["data"]).map(
          ([key, label]) => ({
            label: key,
            value: label,
          })
        );
        setBranchAggregatedData(aggregatedDataArray || []);
      } else {
        setBranchAggregatedData([]);
      }
    },
    (error) => {
      setBranchAggregatedData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const onSelectClickHandler = (data: any) => {
    let url = BASE_URL + MY_BRANCH_LIST;
    url = url + "?facultyId=" + data?.branchId;
    GetBranchData(url);
  };

  useEffect(() => {
    if (Object.keys(LOPDashboard).length) {
      setFilterState({
        ...filterState,
        stream: LOPDashboard ? LOPDashboard?.stream : null,
        clazz: LOPDashboard ? LOPDashboard?.clazz : null,
        region:
          LOPDashboard && LOPDashboard.region != null
            ? LOPDashboard.region
            : null,
        state:
          LOPDashboard && LOPDashboard.state != null
            ? LOPDashboard.state
            : null,
        branchCode:
          LOPDashboard && LOPDashboard.branchCode != null
            ? LOPDashboard.branchCode
            : null,
      });
    } else {
      setFilterState({
        region: null,
        stream:
          masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]
            : null,
        clazz: null,
        state: null,
        branchCode: null,
      });
    }
  }, [masters.streams, LOPDashboard]);

  useEffect(() => {
    const filterLength = Object.values(filterState).filter(
      (ele) => ele != null
    ).length;
    if (Object.keys(LOPDashboard).length) {
      applyFilter(LOPDashboard);
    } else {
      if (masters.streams && masters.streams[0] != undefined) {
        const streamName =
          masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]?.label
            : null;
        const url =
          BASE_URL +
          MY_BRANCH_LIST +
          "?sortBy=" +
          sortColumn +
          "&sortDir=" +
          sortOrder;
        if (filterLength) {
          applyFilter(filterState);
        } else {
          GetBranchData(
            `${url}&stream=${streamName}&limit=${limit}&offset=${0}`
          );
          const aggregatedurl = BASE_URL + MY_BRANCH_AGGREGATED_DATA;
          GetBranchAggregatedData(
            `${aggregatedurl}?stream=${streamName}&limit=${limit}&offset=${0}`
          );
        }
      }
    }
  }, [
    userInfo,
    location,
    masters.streams,
    currentPage,
    limit,
    sortColumn,
    sortOrder,
  ]);
  useEffect(() => {
    if (userInfo?.region) {
      fetchregion();
    }
  }, [userInfo, masters?.regions]);
  const fetchregion = async () => {
    const userAllotedRegiondata = userInfo?.region.split(",");
    if (masters?.regions) {
      const regiondata: any = [];
      masters?.regions.map((item: any) => {
        if (userAllotedRegiondata.includes(String(item.id))) {
          regiondata.push({
            id: item.id,
            key: item.id,
            label: item.label,
            value: item.regionCode,
          });
        }
      });
      setRegion(regiondata);
    }
  };
  const applyFilter = (filterStateObj: any) => {
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        stream: filterStateObj.stream?.label,
        region: filterStateObj.region?.value,
        batchClass: filterStateObj.clazz?.label,
        branchCode: filterStateObj.branchCode
          ?.map((item: any) => item.key)
          ?.toString(),
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + MY_BRANCH_LIST;
      let aggregatedurl = BASE_URL + MY_BRANCH_AGGREGATED_DATA;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
        aggregatedurl = aggregatedurl + "?" + filters2.join("&");
      }
      GetBranchAggregatedData(`${aggregatedurl}&limit=${limit}&offset=${0}`);
      url = url + "&sortBy=" + sortColumn + "&sortDir=" + sortOrder;
      GetBranchData(`${url}&limit=${limit}&offset=${0}`);
    }
  };
  const resetHandler = () => {
    const streamName = masters.streams[0]?.label;
    const url = BASE_URL + MY_BRANCH_LIST;
    const aggregatedurl = BASE_URL + MY_BRANCH_AGGREGATED_DATA;
    GetBranchData(`${url}?stream=${streamName}&limit=${limit}&offset=${0}`);
    GetBranchAggregatedData(`${aggregatedurl}?stream=${streamName}`);
    setFilterState({
      region: null,
      stream: masters.streams[0],
      clazz: null,
      branchCode: null,
      state: null,
    });
  };
  const onLimitChange = (limit: number) => {
    setLimit(limit);
  };

  return (
    <>
      <BranchHealthFilter
        mode="branchHealth"
        onSelectClickHandler={(data: any) => onSelectClickHandler(data)}
        region={region}
        applyFilter={(filterStateObj: any) => {
          setLOPDashboard(filterStateObj);
          applyFilter(filterStateObj);
        }}
        filterState={filterState}
        setFilterState={setFilterState}
        resetHandler={resetHandler}
      />
      <div
        className={["xs", "sm", "md"].includes(screen) ? "" : "pl-5 pr-3 pt-3"}
      >
        <BranchHealthHeader
          aggregatedDataLoading={aggregatedDataLoading}
          aggregatedData={BranchAggregatedData}
        />
      </div>

      <BranchHealthTable
        mode="branchHealth"
        tableloading={tableloading}
        tableHeading={BranchHealthTableHeading}
        tableData={BranchData}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        filterState={filterState}
      />
      <div
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "batchTableContainer pt-0 pb-1"
            : "ml-2 mr-2"
        }
      >
        <Card className="p-3 mb-2 mb-1">
          <Paginator
            module={"test"}
            pagination={pagination}
            pageChanged={(page: any) => setCurrentPage(page)}
            handlePaginationCall={(url: string) => {
              GetBranchData(url);
            }}
            totalItems={BranchData.length}
            limit={limit}
            onLimitChange={onLimitChange}
          />
        </Card>
      </div>
      <BranchhealthTip mode="branchHealth" />
    </>
  );
}

export default BranchHealthHome;
